/**
 * WalterGO Variant Selector
 * Handles variant selection, URL updates, and form synchronization
 */

class WaltergoVariantSelector {
  constructor(container) {
    this.container = container;
    this.options = container.querySelectorAll('[data-variant-option]');
    this.form = document.querySelector('form[action*="/cart/add"]');
    this.variantInput = this.form?.querySelector('input[name="id"]');

    this.init();
  }

  init() {
    this.options.forEach(option => {
      option.addEventListener('click', (e) => {
        e.preventDefault();
        this.selectVariant(option);
      });
    });

    // Sync with URL on load
    this.syncWithUrl();
  }

  selectVariant(selectedOption) {
    const variantId = selectedOption.dataset.variantId;
    const optionType = selectedOption.dataset.optionType;

    // Update visual state for all variant selectors on page
    // Match by optionType (not variantId) because both cards share the same variant ID
    document.querySelectorAll('[data-variant-selector]').forEach(selector => {
      selector.querySelectorAll('[data-variant-option]').forEach(option => {
        const isSelected = option.dataset.optionType === optionType;
        option.classList.toggle('is-selected', isSelected);

        const radio = option.querySelector('.waltergo-radio');
        if (radio) {
          radio.classList.toggle('is-checked', isSelected);
        }
      });
    });

    // Update hidden form variant ID
    if (this.variantInput) {
      this.variantInput.value = variantId;
    }

    // Update URL without page reload
    const url = new URL(window.location);
    url.searchParams.set('variant', variantId);
    window.history.replaceState({}, '', url);

    // Dispatch custom event for other components
    this.container.dispatchEvent(new CustomEvent('variant:changed', {
      detail: { variantId, optionType },
      bubbles: true
    }));

    // Trigger Shopify section refresh if needed
    this.triggerSectionRefresh(variantId);
  }

  syncWithUrl() {
    const url = new URL(window.location);
    const variantId = url.searchParams.get('variant');

    if (variantId) {
      const matchingOption = this.container.querySelector(`[data-variant-id="${variantId}"]`);
      if (matchingOption && !matchingOption.classList.contains('is-selected')) {
        this.selectVariant(matchingOption);
      }
    }
  }

  triggerSectionRefresh(variantId) {
    // Update any price displays
    const priceElements = document.querySelectorAll('[data-product-price]');
    // Price update would require fetching variant data - for now relies on page structure
  }
}

// Initialize on DOM ready
document.addEventListener('DOMContentLoaded', () => {
  const selectors = document.querySelectorAll('[data-variant-selector]');
  selectors.forEach(selector => new WaltergoVariantSelector(selector));
});

// Reinitialize on Shopify section reload (theme editor)
document.addEventListener('shopify:section:load', (e) => {
  const selectors = e.target.querySelectorAll('[data-variant-selector]');
  selectors.forEach(selector => new WaltergoVariantSelector(selector));
});
